<template>
  <div class="image ImageItem">
    <div class="wrapper-img" :class="ske" @click="$emit('show-modal')">
      <img :src="url" height="auto">

      <svg class="expand" xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" viewBox="0 0 24 24" stroke="white">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
      </svg>
      <div class="layer"></div>
    </div>
    <div class="p-2 d-flex justify-content-between align-items-center">
      <span :class="ske">
        <DropdownOptions v-model="activeType"
          class="dropdown-options"
          :remove-arrow="true"
          :options="options"
          :show-id="true"
        >
          <div class="change-image-type-handle">
            <div>
              {{ typeName }}
              <svg xmlns="http://www.w3.org/2000/svg" class="pen" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </div>
            <span class="type">
              {{ type }}
            </span>
          </div>
        </DropdownOptions>
      </span>

      <span :class="ske">
        <svg class="info icon image-delete-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" @click="$emit('remove')">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>

import DropdownOptions from "../DropdownOptions.vue"

export default {
  components: {
    DropdownOptions,
  },
  props: {
    fid: String,
    options: Array,
    forcedSke: Boolean,
    url: String,
    name: String,
    filename: String,
    type: String,
  },
  data() {
    return {
      activeType: this.type,
    }
  },
  computed: {
    ske() {
      return {'forced-ske': this.forcedSke}
    },
    typeName() {
      const type = this.type
      const option = this.options && this.options.find(opt => opt.value === type)
      return option && option.str
    },
  },
  watch: {
    activeType(val) {
      this.$emit("save-new-type", {type: val, fid: this.fid})
    },
  },
}

</script>

<style>

.ImageItem .content-padding {
  padding: 4px !important;
}

</style>

<style scoped>

.dropdown-options {
  border: none !important;
  padding: 0px !important;
  font-size: 0.875em !important;
}

.pen {
  color: #9A9A9A;
  cursor: pointer;
}

.wrapper-img {
  cursor: pointer;
  width: 100%;
  height: 175px;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  transition-duration: .15s;
}

.layer {
  background-color: rgba(0,0,0,.2);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition-duration: .1s;
}

.layer:hover {
  opacity: 1;
}

.change-image-type-handle {
  font-size: 14px !important;
}

.expand {
  transition-duration: .15s;
  position: absolute;
  opacity: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  pointer-events: none;
  z-index: 1;
}

.wrapper-img:hover .expand {
  opacity: 1;
}

.image {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 1px;
}

img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.type {
  display: block;
  text-align: left;
  color: #9A9A9A;
  font-size: 0.75em;
}

.icon {
  color: #9A9A9A;
  cursor: pointer;
}

.icon:hover {
  filter: brightness(0.6);
}

</style>
